import styled from "styled-components";
import { ImageLoader } from "@loanbossinc/component-library";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

export const LABEL_NAMES = {
  BROKER_COMPANY: "Broker Company",
  BROKER_CONTACT: "Broker Contact",
  ASSET_MANAGER: "Asset Manager",
  TEAM_MEMBER: "Team Member",
  NONE_SELECTED: "None Selected",
  BROKER_COMPANY_REQUIRED: "None Selected (Broker Company required)"
};

export const StyledHeader = styled.div`
&& {
    display: flex;
    flex: 1;
    margin: 0 24px;
}`;

export const StyledEditRow = styled.div`
    && {
        display: flex;
        flex: 1;
        margin: 0 24px;

        .input {
            display: flex;
            flex: 1;
            align-items: center;
            max-width: 205px;
            margin-right: auto;
            padding-top: 12px;
            padding-bottom: 12px;
        }
    }
`;

export const StyledImageLoader = styled(ImageLoader)`
    && {
        height: 48px;
        width: 48px;
        margin: .2em;
        align-self: center;
    }
`;

export const StyledDefaultPerson = styled(AccountCircleIcon)`
&& {
    height: 48px;
    width: 48px;
    margin: .2em;
    align-self: center;
}`;

export const StyledNameDiv = styled.div`
&& {
    display: flex;
    flex-direction: column;
    margin-right: auto;
    justify-content: center;
}`;

export const StyledTitle = styled.span`
&& {
    font-family: Work Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    color: #5F6368;
    text-transform: uppercase;
}`;

export const StyledLabel = styled.span`
&& {
    font-family: Work Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0em;
    color: #5F6368;
}`;
